import React from 'react';
import PropTypes from 'prop-types';

const SectionHeader = ({ text }) => (
  <div className="section-header row">
    <div className="column col section-header-column">{text}</div>
  </div>
);

SectionHeader.propTypes = {
  text: PropTypes.string.isRequired,
};

export default SectionHeader;
